import { Id } from '@nextforce/api'

const keys = {
  all: ['chat'],
  conversations: () => [...keys.all, 'conversations'],
  conversation: (conversationId: Id) => [
    ...keys.conversations(),
    conversationId,
  ],
  messages: () => [...keys.all, 'messages'],
  pinnedMessages: (conversationId: Id) => [...keys.messages(), conversationId],
  members: (conversationId: Id, memberIds: Id[]) => [
    ...keys.conversation(conversationId),
    'members',
    memberIds,
  ],
  membersWithAlias: (conversationId: Id) => [
    ...keys.conversation(conversationId),
    'membersWithAlias',
  ],
  recipients: (companyId?: Id) => ['recipients', companyId],
  searchRecipients: (searchTerm?: string, companyId?: Id) => [
    ...keys.recipients(companyId),
    searchTerm,
  ],
  composeRecipients: ['composeRecipients'],
  managersList: (storeId: Id) => [...keys.all, storeId],
  readers: (conversationId: string, messageId: string) => [
    ...keys.conversation(conversationId),
    'messages',
    messageId,
    'readers',
  ],
  readByCounts: (conversationId: string) => [
    ...keys.conversation(conversationId),
    'readByCounts',
  ],
  config: () => [...keys.all, 'config'],
  linkPreview: (url: string) => [...keys.all, 'linkPreview', url],
  emojiActions: (conversationId: string) => ['emojiActions', conversationId],
  conversationPagination: (conversationId: string) => [
    ...keys.conversation(conversationId),
    'pagination',
  ],
}

export default keys
